/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly payment & interest`)
};

const es_ln_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago mensual e interés`)
};

const de_ln_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatliche Rate & Zinsen`)
};

const nl_ln_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijkse betaling & rente`)
};

const fr_ln_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement mensuel et intérêt`)
};

const it_ln_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento mensile e interesse`)
};

const pt_br2_ln_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento mensal e juros`)
};

const pt_ln_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento mensal e juros`)
};

const ja_ln_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「月々の支払額と利息」`)
};

const zh_ln_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月供与利息`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_nav_main_desc", locale)
	if (locale === "en") return en_ln_nav_main_desc(inputs)
	if (locale === "es") return es_ln_nav_main_desc(inputs)
	if (locale === "de") return de_ln_nav_main_desc(inputs)
	if (locale === "nl") return nl_ln_nav_main_desc(inputs)
	if (locale === "fr") return fr_ln_nav_main_desc(inputs)
	if (locale === "it") return it_ln_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_ln_nav_main_desc(inputs)
	if (locale === "pt") return pt_ln_nav_main_desc(inputs)
	if (locale === "ja") return ja_ln_nav_main_desc(inputs)
	return zh_ln_nav_main_desc(inputs)
};